/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import * as authServices from '../services/authService';
import * as accountServices from '../services/accountService'
import * as utilService from '../services/utilService'
import Joinnowpopup from './sub_components/joinnowpopup'
import Loginpopup from './sub_components/loginpopup'
import LoginSportsThumbnailList from './sub_components/loginSportsThumbnailList'
import AboutUs from './sub_components/aboutUs'
import BettingRules from './sub_components/bettingRules'
import DepositsAndWithdrawals from './sub_components/depositsAndWithdrawals'
import PrivacyPolicy from './sub_components/privacyPolicy'
import TermsAndConditions from './sub_components/termsAndConditions'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
import Loginb2cFooter from './loginb2cFooter';
import {showAdminBannerLink, showBHMBannerLink} from '../configs/casinoShowList';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class Loginb2cOffers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection: "",
            clientWidth: document.documentElement.clientWidth,
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }

    async componentDidMount() {
        localStorage.removeItem("homeData")
        if (constants.isDev) {
            this.setState({ isDev: true })
        }
        let savedData = localStorage.getItem("rememberData")
        if (!!savedData) {
            savedData = JSON.parse(savedData)
            if (!!savedData && !!savedData.uid) {
                this.setState({ rememberMe: true, uid: savedData.uid, passcode: !!savedData.passcode ? savedData.passcode : "" })
            }
        }
        if (!window.location.href.includes("apk")) {
            this.setState({ showDownLoad: true })
            localStorage.setItem("appType", "web")
        } else {
            localStorage.setItem("appType", "mobile")
        }


        // headers.append('Referrer-Policy', 'origin');
        // options.referrerPolicy = 'no-referrer-when-downgrade'; Referrer-Policy "origin"
        // headers.append('Accept', '*/*');
        // headers.append('Access-Encoding', 'gzip, deflate, br');
        // headers.append('Connection', 'keep-alive');
        var options = {};
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Origin', '*');
        options.headers = headers;




        // let banners = await utilService.getBanner()
        // let banners = await utilService.getBannerListJson()
        // debugger
        // utilService.getBannerListJson().then((res)=>{
        //     if(!!res){
        //         let desktop_banners_arr = res.desktop
        //         let mobile_banners_arr = res.mobile

        //         let desktop_banners = {}
        //         for (var banner of desktop_banners_arr) {
        //             desktop_banners[banner.split(".")[0]] = `https://images.staticcontents.com/banners/desktop_banner_${banner}`
        //         }

        //         let mobile_banners = {}
        //         for (var mobbanner of mobile_banners_arr) {
        //             mobile_banners[mobbanner.split(".")[0]] = `https://images.staticcontents.com/banners/mobile_banner_${mobbanner}`
        //         }

        //         this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
        //     }
        // })
        if(showAdminBannerLink){
            utilService.getOperatorBannerListJson().then((res) => {
                if (!!res) {
                    let desktop_banners_arr = res.desktop
                    let mobile_banners_arr = res.mobile
    
                    let desktop_banners = {}
                    for (var banner of desktop_banners_arr) {
                        desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/desktop_banner_${banner}`
                    }
    
                    let mobile_banners = {}
                    for (var mobbanner of mobile_banners_arr) {
                        mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/mobile_banner_${mobbanner}`
                    }
                    
                    this.setState({ operatorDesktopBanners: desktop_banners, operatorMobileBanners: mobile_banners },()=>{
                        if(showBHMBannerLink){
                            utilService.getBannerListJson().then((res) => {
                                if (!!res) {
                                    let desktop_banners_arr = res.desktop
                                    let mobile_banners_arr = res.mobile
                                    
                                    let desktop_banners = {}
                                    for (var banner of desktop_banners_arr) {
                                        desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`
                                    }
                                    let mobile_banners = {}
                                    for (var mobbanner of mobile_banners_arr) {
                                        mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`
                                    }
                    
                                    this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
                                }
                            })
                        }
                    })
                }
            })
        } else { 
            if(showBHMBannerLink){ 
                utilService.getBannerListJson().then((res) => {
                    if (!!res) {
                        let desktop_banners_arr = res.desktop
                        let mobile_banners_arr = res.mobile

                        let desktop_banners = {}
                        for (var banner of desktop_banners_arr) {
                            desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`
                        }

                        let mobile_banners = {}
                        for (var mobbanner of mobile_banners_arr) {
                            mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`
                        }

                        this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
                    }
                })
            }
        }
        // if (!!banners.items && banners.items.length > 0 && banners.isSuccess) {

        //     let desktop_banners_arr = banners.items.filter((banner) => { return banner.includes("desktop_banner") })
        //     let mobile_banners_arr = banners.items.filter((banner) => { return banner.includes("mobile_banner") })

        //     let desktop_banners = {}
        //     for (var banner of desktop_banners_arr) {
        //         desktop_banners[banner.split("_")[2].split(".")[0]] = banner
        //     }

        //     let mobile_banners = {}
        //     for (var mobbanner of mobile_banners_arr) {
        //         mobile_banners[mobbanner.split("_")[2].split(".")[0]] = mobbanner
        //     }

        //     this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
        // }
    }



    // showToast(msg, type) {
    //     let self = this
    //     this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
    //         setTimeout(() => {
    //             self.setState({ toastMsg: "", toastType: "", showToast: false })
    //         }, 3000);
    //     })
    // }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }

    handleKey(e) {
        if (e.keyCode === 13) {
            this.signIn();
        }
    }

    signIn() {
        let body = {
            "username": this.state.uid.trim().toLowerCase(),
            "password": this.state.passcode
        }
        if (!this.state.uid.trim()) {
            this.props.notify("Please Insert Username!", "error")
            return false
        }
        if (!this.state.passcode) {
            this.props.notify("Please Insert Password!", "error")
            return false
        }
        if (this.state.rememberMe) {
            let data = {
                "uid": this.state.uid.trim().toLowerCase(),
                "passcode": this.state.passcode
            }
            localStorage.setItem("rememberData", JSON.stringify(data))
        } else {
            localStorage.removeItem("rememberData")
        }
        authServices.signin(body).then(async (result) => {
            if (result.token) {
                let data = {
                    token: result.token
                }
                let accessControl = {
                    sports: true,
                    binary: true,
                    casino: true
                }
                localStorage.setItem("userAuthDetail", JSON.stringify(data))
                let velidateData = await authServices.velidateToken()

                if (!!velidateData.role && velidateData.role === "Client") {
                    localStorage.setItem("tokenData", JSON.stringify(velidateData))
                    localStorage.setItem("accessControl", JSON.stringify(accessControl))
                    let accData = await accountServices.getAccountData()
                    if (!!accData && !!accData.userLock && accData.userLock) {
                        this.props.notify("User Is Locked. Please Contact Upperline!", "error")
                        this.logout()
                    }
                    localStorage.setItem("accountData", JSON.stringify(accData))
                    let configData = await authServices.getConfigButton()
                    localStorage.setItem("buttonsValues", JSON.stringify(configData))
                    if (velidateData.pwdch) {
                        this.props.history.push("/setpassword");
                    }
                    else {
                        // this.props.history.push("/home");
                        window.location.href = "/home"
                    }
                } else if (!!velidateData.role && velidateData.role !== "Client") {
                    this.props.notify(velidateData.role + " user is not allow to access this portal.", "error")
                } else {
                    this.props.notify(velidateData.exception.message, "error")
                }
            } else {
                this.props.notify(result.exception.message, "error")
            }
        })
    }

    logout() {
        let appType = localStorage.getItem("appType")
        let rememberData = localStorage.getItem("rememberData")
        localStorage.clear()
        localStorage.setItem("rememberData", rememberData)
        if (appType === "mobile") {
            window.location.href = window.location.origin + "/apk";
        } else {
            window.location.href = window.location.origin + "/auth";
        }
    }

    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]: false })

    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = "") {
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name) {
        this.setState({ selectedSection: this.state.selectedSection === name ? "" : name });
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
            <div className="radheexch radheexchlogin bg-white-login">
                <Loginb2cHeader history={this.props.history} selectedSection={this.state.selectedSection} toggleSelectedSection={(view) => this.toggleSelectedSection(view)} showSweetAlert={(options) => this.props.showSweetAlert(options)} notify={this.props.notify}></Loginb2cHeader>
                <div className='login-mar-top100'>
                    <section className='sportbook-livecasino'>
                        <div className="subpage-head">
                            <div className="subpage-head__image">
                                <img alt="Offers Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/offers-banner.jpg"} />
                            </div>
                            <div className="subpage-head__content">
                                <h1 className="subpage-head__title">1XBOOK</h1>
                                <div className="subpage-head__subtitle">Offers</div>
                            </div>
                        </div>
                    </section>
                    <section id="ft-service" className="ft-service-section">
                        <div className="container">
                            <div className="ft-service-content">
                                <div className="row">

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                        <div className="ft-service-slider-area">
                                            <div className="ft-service-slider-wrapper">
                                                <div className="ft-item-innerbox wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                                                    <div className="ft-service-slider-item">
                                                        <div className="ft-service-inner-img">
                                                            <img alt="Offer1" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/offers-banner/offer1.jpg"} />
                                                        </div>
                                                        <div className="ft-service-inner-text headline pera-content position-relative">
                                                            <h3><a href="service-single.html">Offer 1 </a></h3>
                                                            <p>10% Bonus* On First Deposit. T&C Applicable.</p>
                                                            <a className="service-more" onClick={(e) => { this.showPopup("Login") }}>Get Started <span>+</span></a>
                                                            <div className="ft-service-serial position-absolute">
                                                                1
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                        <div className="ft-service-slider-area">
                                            <div className="ft-service-slider-wrapper">
                                                <div className="ft-item-innerbox wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                                                    <div className="ft-service-slider-item">
                                                        <div className="ft-service-inner-img">
                                                            <img alt="Offer2" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/offers-banner/offer2.jpg"} />
                                                        </div>
                                                        <div className="ft-service-inner-text headline pera-content position-relative">
                                                            <h3><a href="service-single.html">Offer 2</a></h3>
                                                            <p>7% Bonus* On Every Deposit T&C Applicable.</p>
                                                            <a className="service-more" onClick={(e) => { this.showPopup("Login") }}>Get Started <span>+</span></a>
                                                            <div className="ft-service-serial position-absolute">
                                                                2
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                        <div className="ft-service-slider-area">
                                            <div className="ft-service-slider-wrapper">
                                                <div className="ft-item-innerbox wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                                                    <div className="ft-service-slider-item">
                                                        <div className="ft-service-inner-img">
                                                            <img alt="Offer3" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/offers-banner/offer3.jpg"} />
                                                        </div>
                                                        <div className="ft-service-inner-text headline pera-content position-relative">
                                                            <h3><a href="service-single.html">Offer 3</a></h3>
                                                            <p>2% Flat Bonus on Every Deposit T&C Applicable. </p>
                                                            <a className="service-more" onClick={(e) => { this.showPopup("Login") }}>Get Started <span>+</span></a>
                                                            <div className="ft-service-serial position-absolute">
                                                                3
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <Loginb2cFooter history={this.props.history} showSweetAlert={(options) => this.props.showSweetAlert(options)} notify={this.props.notify}></Loginb2cFooter>





                {/* {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />} */}
                {this.state.showPopup && <Joinnowpopup hidePopup={() => { this.hidePopup() }} showSweetAlert={(options) => this.props.showSweetAlert(options)} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} toggleSelectedSection={(name) => { this.toggleSelectedSection(name) }} />}
                {this.state.showLoginPopup && <Loginpopup hidePopup={() => { this.hidePopup("Login") }} showSweetAlert={(options) => this.props.showSweetAlert(options)} history={this.props.history} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} />}


            </div>)
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Loginb2cOffers);